<template>
  <v-layout align-center column style="margin-top:100px;">
    <p class="Section-Title">Meet Our Leaders</p>
    <v-row align="center" justify="center" class="leadersContainer">
      <v-col>
        <p class="Name" v-bind:style="{ marginLeft: textMarginLeft }">
          Sunu Widyatmoko
        </p>
        <p class="Position" v-bind:style="{ marginLeft: textMarginLeft }">
          Direksi
        </p>
        <img
          src="../../assets/TentangKami/Sunu-Widyatmoko.png"
          srcset="
            ../../assets/TentangKami/Sunu-Widyatmoko@2x.png 2x,
            ../../assets/TentangKami/Sunu-Widyatmoko@3x.png 3x
          "
          class="Sunu-Widyatmoko Image"
        />
        <a
          class="no-line"
          href="https://id.linkedin.com/in/sunu-widyatmoko-b13455b"
        >
          <div class="Shape">
            <img
              src="../../assets/TentangKami/linkedin.png"
              srcset="
                ../../assets/TentangKami/linkedin@2x.png 2x,
                ../../assets/TentangKami/linkedin@3x.png 3x
              "
              class="linkedin"
            />
            <span class="title-1">Let's connect!</span>
          </div>
        </a>
      </v-col>
      <v-col>
        <p class="Name" v-bind:style="{ marginLeft: textMarginLeft }">
          Endra Masagung
        </p>
        <p class="Position" v-bind:style="{ marginLeft: textMarginLeft }">
          Dewan Komisaris
        </p>
        <img
          src="../../assets/TentangKami/Endra-Masagung-2.png"
          class="Endra-Masagung Image"
        />
        <a
          class="no-line"
          href="https://id.linkedin.com/in/endra-masagung-47984ab"
        >
          <div class="Shape">
            <img
              src="../../assets/TentangKami/linkedin.png"
              srcset="
                ../../assets/TentangKami/linkedin@2x.png 2x,
                ../../assets/TentangKami/linkedin@3x.png 3x
              "
              class="linkedin"
            />
            <span class="title-1">Let's connect!</span>
          </div>
        </a>
      </v-col>
      <v-col>
        <p class="Name" v-bind:style="{ marginLeft: textMarginLeft }">
          Arif Medianto
        </p>
        <p class="Position" v-bind:style="{ marginLeft: textMarginLeft }">
          Dewan Komisaris
        </p>
        <img
          src="../../assets/TentangKami/Arif-Medianto.png"
          srcset="
            ../../assets/TentangKami/Arif-Medianto@2x.png 2x,
            ../../assets/TentangKami/Arif-Medianto@3x.png 3x
          "
          class="Arif-Medianto Image"
        />
        <a
          class="no-line"
          href="https://id.linkedin.com/in/arifmedianto?trk=people-guest_people_search-card"
        >
          <div class="Shape">
            <img
              src="../../assets/TentangKami/linkedin.png"
              srcset="
                ../../assets/TentangKami/linkedin@2x.png 2x,
                ../../assets/TentangKami/linkedin@3x.png 3x
              "
              class="linkedin"
            />
            <span class="title-1">Let's connect!</span>
          </div>
        </a>
      </v-col>
      <v-col>
        <p class="Name" v-bind:style="{ marginLeft: textMarginLeft }">
          Sandrine Azhar
        </p>
        <p class="Position" v-bind:style="{ marginLeft: textMarginLeft }">
          Direksi
        </p>
        <img
          src="../../assets/TentangKami/Sandrine-Azhar.png"
          srcset="
            ../../assets/TentangKami/Sandrine-Azhar@2x.png 2x,
            ../../assets/TentangKami/Sandrine-Azhar@3x.png 3x
          "
          class="Arif-Medianto Image"
        />
        <a
          class="no-line"
          href="https://id.linkedin.com/in/sandrine-azhar-08344b4b"
        >
          <div class="Shape">
            <img
              src="../../assets/TentangKami/linkedin.png"
              srcset="
                ../../assets/TentangKami/linkedin@2x.png 2x,
                ../../assets/TentangKami/linkedin@3x.png 3x
              "
              class="linkedin"
            />
            <span class="title-1">Let's connect!</span>
          </div>
        </a>
      </v-col>
    </v-row>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      heroTextSize: `48px`,
      textMarginLeft: `${window.innerWidth / 8}px`,
      marginTop: `${window.innerWidth / 6}px`,
      width: `${window.innerWidth / 4}px`,
      fontSize: `40px`,
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.textMarginLeft = `${window.innerWidth / 40}px`;
      this.marginTop = `${window.innerWidth / 7}px`;
      this.width = `${window.innerWidth / 2}px`;
      this.fontSize = `${window.innerWidth / 32}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
};
</script>
<style scoped>
.Shape {
  width: 200px;
  height: 44px;
  flex-grow: 0;
  margin-top: 12px;
  margin-left: 15%;
  border-radius: 22px;
  border: solid 2px #252525;
  background-color: #ffffff;
}
.Section-Title {
  width: 300px;
  height: 30px;
  flex-grow: 0;
  margin: 0px 206px 30px;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Quote-Text {
  width: 590px;
  height: 44px;
  flex-grow: 0;
  margin: 16px 20px 30px;
  font-family: Inter;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Name {
  width: 200px;
  flex-grow: 0;
  margin: 300px auto 20px auto;
  font-family: Sora;
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  position: absolute;
}
.Position {
  width: 200px;
  flex-grow: 0;
  margin: 320px 0 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  position: absolute;
}
.Sunu-Widyatmoko {
  width: 285px;
  height: 350px;
  flex-grow: 0;
  object-fit: contain;
}
.linkedin {
  width: 18px;
  height: 18px;
  flex-grow: 0;
  margin: 10px 8px -2px 35px;
  object-fit: contain;
}
.Endra-Masagung {
  width: 285px;
  height: 350px;
  flex-grow: 0;
  object-fit: contain;
}
.Arif-Medianto {
  width: 285px;
  height: 350px;
  flex-grow: 0;
  object-fit: contain;
}
.Image {
  width: 285px;
  height: 350px;
  flex-grow: 0;
  border-radius: 8px;
  box-shadow: 0 4px 35px 0 rgba(0, 0, 0, 0.05);
}
.title-1 {
  width: 101px;
  height: 18px;
  flex-grow: 0;
  font-family: Sora;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
  outline: none;
}
.no-line {
  color: #ffffff;
}
@media screen and (max-width: 1300px) {
  .leadersContainer {
    width: 90%;
    margin-left: 5%;
  }
}
@media screen and (max-width: 1000px) {
  .leadersContainer {
    width: 95%;
    margin-left: 2.5%;
  }
}
@media screen and (max-width: 900px) {
  .leadersContainer {
    width: 100%;
    margin-left: 0;
  }
}
</style>
